import { createSelector } from "reselect"
import { chain, get, find, map } from "lodash"
import { FACTORS, CATEGORIES, getCurrent } from "./forecast"

const getRawDisplayType = state => get(state, "modules.analyzeForecast.displayType")

function getFactorLabel(factors, id) {
  const factor = get(factors, id, { label: id })
  return factor.label
}

function getFactorCategory(factors, id) {
  return get(factors, [id, "category"])
}

export const getDisplayType = createSelector(
  [getRawDisplayType],
  (displayType) => {
    if (find(CATEGORIES, cat => cat.id === displayType)) {
      return displayType
    }

    return CATEGORIES[0].id
  },
)

export const getDisplayTypeName = createSelector(
  [getRawDisplayType],
  (displayType) => {
    const category = find(CATEGORIES, cat => cat.id === displayType)
    if (category) {
      return category.label
    }

    return CATEGORIES[0].label
  },
)

export const getAllItems = createSelector(
  [getCurrent],
  (lastDatum) => {
    return map(FACTORS, (_, id) => ({
      id,
      label: getFactorLabel(FACTORS, id),
      category: getFactorCategory(FACTORS, id),
      lastValue: get(lastDatum, ["factors", id], 0),
      field: `factors.${id}`,
      disabled: false,
    }))
  },
)

export const getAllCategoryItems = createSelector(
  [getAllItems, getDisplayType],
  (items, displayType) => chain(items)
    .filter(item => item.category === displayType)
    .orderBy(item => Math.abs(item.lastValue), ["desc"])
    .value(),

)

export const getOrderedCategoryItems = createSelector(
  [getAllItems, getDisplayType],
  (items, displayType) => chain(items)
    .filter(item => item.category === displayType)
    .orderBy(item => Math.abs(item.lastValue), ["asc", "desc"])
    .value(),
)
